import type { IValidationErrorDto } from "@/types/FormEngine/validation";
import { defineComponent } from "vue";
import {t} from "@/services/Translation/t";
export default defineComponent({
  name: "Label",
  props: {
    identifier: { type: String },
    mtdt: {
      type: Object as IField | any,
    },
    level: {type : Number}
  },
  data(vm) {

    return {
      defaultState: {
        isValid: true,
        hidden: this.mtdt.IsHidden,
        readOnly: this.mtdt.ReadOnlyFlag,
        hiddenLabel: this.mtdt.HasHiddenLabel === null ? false : (this.mtdt.HasHiddenLabel as boolean),
        hiddenHint: false,
        description: this.mtdt.Description,
      },
      state: {
        hidden: this.mtdt.IsHidden === null ? false : this.mtdt.IsHidden,
        description: this.mtdt.Description,
        isValid: true,
        errorMessages: new Array<IValidationErrorDto>(),
        readOnly: this.mtdt.ReadOnlyFlag,
        hiddenLabel: this.mtdt.HasHiddenLabel === null ? false : (this.mtdt.HasHiddenLabel as boolean),
        hiddenHint: false,
      },
    };
  },
  created() {
    window.FormEngine.form.registerControl(this.identifier, this);
  },
  computed: {
    displayName(): string {
      return t("Name", this.identifier);
    },
    displayHint(): string {
      return t("Hint", this.identifier);
    },
    displayTitle(): string {
      return t("Title", this.identifier);
    },
    hintId() {
      return this.identifier + "-hint";
    },
    errorId() {
      return this.identifier + "-error";
    },
    titleId() {
      return this.identifier + "-title";
    },
    displayHintText(): string {
      return (this.state.hiddenHint) ? t("displayHintTextClosed", "_utility") : t("displayHintTextOpened", "_utility");
    },
    nameId(){
      return this.identifier + "-label";
    }
  },
  methods: {
    validate(fillErrorBag: boolean = true) {
      // return window.FormEngine.form.validation.validate(
      //   {
      //     validableId: this.identifier,
      //     control: this,
      //     from: "",
      //     to: "",
      //   },
      //   fillErrorBag
      // );
    },
    toggleHintSection() {
      this.state.hiddenHint = !this.state.hiddenHint;
    },
    hide(){
      this.state.hidden = true;
    },
    show(){
      this.state.hidden = false;
    },
    subscribe(event: string, callback: Function) {
      window.FormEngine.events.subscribe(event, callback, this.identifier);
    },
    getValue(){
      return "LABEL NEMA VALUE!";
    },
    setToExport(toExport: boolean) {
    },
  },
});
